import React from "react";
import styled from "styled-components";
import {GreyContent} from "../../../../../theme/variable";
import {loaderanimationRule} from "../../../../CommonContentLoaderStyled/widgets/Styled";
import {media} from "../../../../../theme/responsive.js";

export const ExamScoreLoaderDiv = styled.div`
    width: 100%;
    display: inline-block;
`;
export const ExamScoreLoaderBox = styled.div`
    width: 50%;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 15px;
    ${media.laptop`width:25%;`}
`;
export const ExamScoreLoaderSection = styled.div`
    display: inline-block;
    vertical-align: middle;
    width: 50%;
`;
export const ExamNameLoader = styled.div`
    width: 40px;
    height: 16px;
    margin-left: 10px;
    background: ${GreyContent};
    display: inline-block;
    animation: ${loaderanimationRule};
`;
export const ExamCheckBoxDiv = styled.div`
    width: 16px;
    height: 16px;
    border: 1px solid ${GreyContent};
    border-radius: 2px;
    display: inline-block;
`;
export const ExamScoreBox = styled.div`
    border: 1px solid ${GreyContent};
    width: 68px;
    height: 48px;
    display: inline-block;
    padding: 14px 8px;
    vertical-align: middle;
    border-radius: 4px;
    > div {
        background: ${GreyContent};
        width: 50px;
        height: 16px;
        animation: ${loaderanimationRule};
    }
`;
export const ExamScoreLoader = () => {
    return (
        <ExamScoreLoaderDiv>
            {[1, 2, 3, 4].map((index) => {
                return (
                    <ExamScoreLoaderBox key={index}>
                        <ExamScoreLoaderSection>
                            <ExamCheckBoxDiv />
                            <ExamNameLoader />
                        </ExamScoreLoaderSection>
                        <ExamScoreBox>
                            <div />
                        </ExamScoreBox>
                    </ExamScoreLoaderBox>
                );
            })}
        </ExamScoreLoaderDiv>
    );
};
export default ExamScoreLoader();
